<angular-alerts-outlet></angular-alerts-outlet>
<tr-loader></tr-loader>
<router-outlet></router-outlet>

<ng-template #socketErrorMessageTmpl>
  It looks like there's a problem with your connection. <a href='javascript:void(0);' (click)='reload()'><strong>Click
      here to reload</strong></a>.
</ng-template>
